export default function SegmentContainer({ children, className, style }) {
  return (
    <div className={`bg-cover bg-center ${className}`} style={style}>
      <div className="relative h-full max-w-6xl m-auto px-6 sm:px-12">
        {children}
      </div>
    </div>
  );
}
